/**
 * FAQ Accordion – steuert nur Sichtbarkeit/ARIA-Status.
 * Der Inhalt (Frage + Antwort) liegt bereits vollständig im initialen HTML
 * und wird durch dieses Skript nicht nachgeladen, sondern nur ein-/ausgeblendet.
 */
(function () {
  function initFaq(root) {
    var triggers = root.querySelectorAll('.faq-item__trigger');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        toggle(trigger);
      });

      // Pfeiltasten-Navigation zwischen den Fragen (optionales, aber empfohlenes a11y-Pattern)
      trigger.addEventListener('keydown', function (event) {
        var list = Array.prototype.slice.call(triggers);
        var index = list.indexOf(trigger);

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          var next = list[index + 1] || list[0];
          next.focus();
        }

        if (event.key === 'ArrowUp') {
          event.preventDefault();
          var prev = list[index - 1] || list[list.length - 1];
          prev.focus();
        }

        if (event.key === 'Home') {
          event.preventDefault();
          list[0].focus();
        }

        if (event.key === 'End') {
          event.preventDefault();
          list[list.length - 1].focus();
        }
      });
    });
  }

  function toggle(trigger) {
    var expanded = trigger.getAttribute('aria-expanded') === 'true';
    var panelId = trigger.getAttribute('aria-controls');
    var panel = document.getElementById(panelId);

    trigger.setAttribute('aria-expanded', String(!expanded));

    if (panel) {
      panel.hidden = expanded;
    }
  }

  document.querySelectorAll('.faq-list').forEach(function (list) {
    initFaq(list);
  });
})();
